import { useEffect, useState } from 'react';
import { Headline6, Subtitle2 } from '@material/react-typography';
import { Checkbox } from '@upmc/ims.component-library';
import { formatForID } from '../../../utils/strings/StringUtil';
import useDebounce from '../../../utils/hooks/useDebounce';
import classes from './Input.module.scss';
import Multiselect from '../../../pages/ApplicationRequest/components/Input/Multiselect';
import DateSelect from './DateSelect/DateSelect';
import ModelAfter from './InputElements/ModelAfter/ModelAfter';
import AppRequestPrimarySearch from './PersonSearch/variants/AppRequestPrimarySearch';
import RadioSet from '../MDC/Radio/RadioSet/RadioSet';
import Radio from '../MDC/Radio/Radio';
import StyleAuxiliary from '../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import Toggle from '../MDC/Toggle/Toggle';
import AcceptDecline from '../../../pages/ApplicationRequest/components/Input/AcceptDecline/AcceptDecline';
import ComponentContainer from './ComponentContainer/componentContainer';
import ExpandingComponentContainerList from './ComponentContainer/expandingComponentContainerList';
import PopupIconButton from './PopupIconButton/PopupIconButton';
import EpicEpicCare from '../../../pages/ApplicationRequest/components/containers/79/EpicEpicCare';
import RequiredIndicator from '../../../pages/ApplicationRequest/components/containers/RequiredIndicator';
import HealthPlanetPPG from '../../../pages/ApplicationRequest/components/containers/317/HealthPlanetPPG';
import Bridges from 'pages/ApplicationRequest/components/containers/1616BridgesEpic/Bridges';
import BridgesLink from 'pages/ApplicationRequest/components/containers/1617BridgesLink/FormView';
import ADGroupsSearch from 'pages/ApplicationRequest/components/containers/158ADGroups/components/ADGroupsSearch';
import EpicHP from 'pages/ApplicationRequest/components/containers/1696EpicHP/EpicHP';

const Input = props => {
	const [textboxValue, setTextboxValue] = useState(props.value);
	const [textboxEvent, setTextboxEvent] = useState(null);
	const debouncedTextboxEvent = useDebounce(textboxEvent, 1000);

	useEffect(() => {
		if (debouncedTextboxEvent && debouncedTextboxEvent.target) {
			props.changeHandler(debouncedTextboxEvent);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [debouncedTextboxEvent]);

	const getProcessedSublabel = propssublabel => {
		let sublabelOutput = [];
		if (
			propssublabel &&
			sublabelNeeded &&
			extras?.hyperlink?.sublabel &&
			extras.hyperlink.sublabel.length > 0
		) {
			const pieces = propssublabel.split(' ');
			pieces.forEach(piece => {
				const hyperlink = extras.hyperlink.sublabel.find(
					x => '$' + x.key === piece
				);
				if (hyperlink) {
					sublabelOutput.push(
						<a
							href={hyperlink.url}
							target='_blank'
							id={`app-${props.appId}__component-${parseInt(
								props.name
							)}__hyperlink-${formatForID(hyperlink.text)}`}
							rel='noopener noreferrer'
						>
							{hyperlink.text}{' '}
						</a>
					);
				} else {
					sublabelOutput.push(<span>{piece} </span>);
				}
			});
			return sublabelOutput;
		}
		return propssublabel;
	};

	let inputElement = null;
	if (
		props.validation &&
		!props.validation.valid &&
		props.validation.touched &&
		!props.styleClasses.includes('invalid-feedback')
	) {
		props.styleClasses.push('invalid-feedback');
	} else if (
		props.validation &&
		props.validation.valid &&
		props.validation.touched &&
		props.styleClasses.includes('invalid-feedback')
	) {
		props.styleClasses.pop();
	}

	if (props.elementConfig.styles && props.elementConfig.styles.length > 0) {
		for (let i in props.elementConfig.styles) {
			props.styleClasses.push(props.elementConfig.styles[i]);
			props.styleClasses.push(classes[props.elementConfig.styles[i]]);
		}
	} else {
		props.styleClasses.push('form-control');
	}
	let elementStyles = props.styleClasses.join(' ');
	let isFormField = false;
	let labelNeeded = true;
	let sublabelNeeded = true;
	let errorMessageNeeded = true;
	const extras = JSON.parse(props.extras);
	let containerList = false;
	if (extras && extras.containerList) {
		containerList = extras.containerList;
	}
	let indent = false;
	if (containerList || (extras && extras.indent)) {
		indent = true;
	}
	const styleInteractive = indent
		? 'interactive-element-indented'
		: 'interactive-element';

	switch (props.elementType) {
		case 'acceptdecline':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<AcceptDecline
						{...props}
						name={props.name}
						appId={props.appId}
						onChange={props.changeHandler}
						value={props.value ? props.value : ''}
						extras={extras}
					/>
				</div>
			);
			break;
		case 'popupiconbutton':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<PopupIconButton
						{...props}
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}`}
						{...extras}
					/>
				</div>
			);
			break;
		case 'checkbox':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<div>
						<Checkbox
							name={props.name}
							inputProps={{
								id: `app-${props.appId}__component-${parseInt(
									props.name
								)}`,
							}}
							value={props.label}
							{...props.elementConfig}
							onChange={props.changeHandler}
							checked={props.value === props.label}
							label={props.label}
						/>
					</div>
				</div>
			);
			labelNeeded = false;
			break;
		case 'checkboxlist':
			let disabled = extras && extras.disabled ? extras.disabled : [];
			inputElement = (
				<div className={classes[styleInteractive]}>
					{Object.keys(props.elementConfig.options).map(option =>
						Object.keys(
							props.elementConfig.options[option].ApplicationData
						).map(appData => {
							let selectedValues = [];
							if (props.value) {
								selectedValues = props.value.split('~~');
							}
							let isChecked = false;
							for (let selection in selectedValues) {
								isChecked =
									props.elementConfig.options[option]
										.ApplicationData[appData].Value ===
									selectedValues[selection];
								if (isChecked) {
									break;
								}
							}
							return (
								<div key={appData}>
									<Checkbox
										name={props.name}
										inputProps={{
											id: `app-${
												props.appId
											}__component-${parseInt(
												props.name
											)}__option-${
												props.elementConfig.options[
													option
												].ApplicationData[appData].Key
											}`,
										}}
										value={
											props.elementConfig.options[option]
												.ApplicationData[appData].Value
										}
										{...props.elementConfig}
										onChange={props.changeHandler}
										checked={isChecked}
										disabled={disabled.includes(
											props.elementConfig.options[option]
												.ApplicationData[appData].Key
										)}
										label={
											props.elementConfig.options[option]
												.ApplicationData[appData].Value
										}
									/>
								</div>
							);
						})
					)}
				</div>
			);
			break;
		case 'container':
			labelNeeded = false;
			inputElement = (
				<ComponentContainer
					appId={props.appId}
					componentId={props.name}
					label={props.label}
					containerList={containerList}
					indent={indent}
					extras={extras}
				/>
			);
			break;
		case 'containerlist':
			inputElement = (
				<ExpandingComponentContainerList
					appId={props.appId}
					componentId={props.name}
					label={props.label}
					name={props.name}
					onChange={props.changeHandler}
					extras={extras}
				/>
			);
			break;
		case 'datepicker':
			inputElement = (
				<StyleAuxiliary className={classes[styleInteractive]}>
					<DateSelect
						name={props.name}
						appId={props.appId}
						componentId={parseInt(props.name)}
						onChange={props.changeHandler}
						value={props.value ? props.value : ''}
						extras={extras}
					/>
				</StyleAuxiliary>
			);
			break;
		case 'dropdown':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<select
						{...props.elementConfig}
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}`}
						value={props.value ? props.value : ''}
						onChange={props.changeHandler}
						className={elementStyles}
						disabled={
							extras &&
							extras.disabled &&
							extras.disabled.length > 0
								? true
								: false
						}
					>
						<option key='select a value' value=''>
							--select--
						</option>

						{Object.keys(props.elementConfig.options).map(key =>
							Object.keys(
								props.elementConfig.options[key].ApplicationData
							).map(innerKey => {
								let selectedValues = [];
								if (props.value) {
									selectedValues = props.value.split('~~');
								}
								let isChecked = false;
								for (let selection in selectedValues) {
									isChecked =
										props.elementConfig.options[key]
											.ApplicationData[innerKey].Value ===
										selectedValues[selection];
									if (isChecked) {
										break;
									}
								}
								return (
									<option
										key={
											props.elementConfig.options[key]
												.ApplicationData[innerKey].Key
										}
										id={`app-${
											props.appId
										}__component-${parseInt(
											props.name
										)}__option-${formatForID(
											props.elementConfig.options[key]
												.ApplicationData[innerKey].Value
										)}`}
										value={
											props.elementConfig.options[key]
												.ApplicationData[innerKey].Value
										}
										selected={isChecked}
									>
										{
											props.elementConfig.options[key]
												.ApplicationData[innerKey].Value
										}
									</option>
								);
							})
						)}
					</select>
				</div>
			);
			break;
		case 'hyperlink':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<a
						href={props.sublabel}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}`}
						name={props.name}
						target='_blank'
						rel='noopener noreferrer'
					>
						{props.label}
					</a>
				</div>
			);
			labelNeeded = false;
			sublabelNeeded = false;
			break;
		case 'modelafter':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<ModelAfter
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}`}
						appId={props.appId}
						{...props}
					/>
				</div>
			);
			break;
		case 'multiselect':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<Multiselect
						appId={props.appId}
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}`}
						elementConfig={props.elementConfig}
						extras={extras}
						label={props.label}
						value={props.value}
						changeHandler={props.changeHandler}
					/>
				</div>
			);
			break;
		case 'primarysearch':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<AppRequestPrimarySearch
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}`}
						appId={props.appId}
						{...props}
					/>
				</div>
			);
			break;
		case 'toggle':
			inputElement = (
				<div>
					<Toggle
						changeHandler={props.changeHandler}
						elementConfig={props.elementConfig}
						formElId={props.formElId}
						key={props.key}
						label={props.label}
						name={props.name}
						nativeControlId={`app-${
							props.appId
						}__component-${parseInt(props.name)}`}
						value={props.value}
					/>
				</div>
			);
			isFormField = true;
			break;
		case 'radiobuttonlist':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<RadioSet isVert changeHandler={props.changeHandler}>
						{Object.keys(props.elementConfig.options).map(option =>
							Object.keys(
								props.elementConfig.options[option]
									.ApplicationData
							).map(appData => {
								let selectedValues = [];
								if (props.value) {
									selectedValues = props.value.split('~~');
								}
								let isChecked = false;
								for (let selection in selectedValues) {
									isChecked =
										props.elementConfig.options[option]
											.ApplicationData[appData].Value ===
										selectedValues[selection];
									if (isChecked) {
										break;
									}
								}
								const label =
									props.elementConfig.options[option]
										.ApplicationData[appData].Value;
								return (
									<Radio
										checked={isChecked}
										key={
											props.elementConfig.options[option]
												.ApplicationData[appData].Key
										}
										label={label}
										id={`app-${
											props.appId
										}__component-${parseInt(
											props.name
										)}__option-${
											props.elementConfig.options[option]
												.ApplicationData[appData].Key
										}`}
										name={props.name}
										value={label}
										disabled={
											extras &&
											extras.disabled &&
											extras.disabled.length > 0
												? true
												: false
										}
									/>
								);
							})
						)}
					</RadioSet>
				</div>
			);
			break;
		case 'textbox':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<input
						type={
							props.elementSubtype ? props.elementSubtype : 'text'
						}
						{...props.elementConfig}
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}`}
						value={textboxValue}
						onChange={e => {
							setTextboxEvent(e);
							setTextboxValue(e.target.value);
						}}
						className={elementStyles}
						refs={props.refs}
						disabled={
							extras &&
							extras.disabled &&
							extras.disabled.length > 0
								? true
								: false
						}
					/>
				</div>
			);
			break;
		case 'textarea':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<textarea
						{...props.elementConfig}
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}`}
						value={props.value ? props.value : ''}
						onChange={props.changeHandler}
						className={elementStyles}
						refs={props.refs}
					/>
				</div>
			);
			break;
		case 'paragraph':
			inputElement = (
				<div className={classes[styleInteractive]}>
					<p
						{...props.elementConfig}
						name={props.name}
						value={props.value ? props.value : ''}
						onChange={props.changeHandler}
						refs={props.refs}
						className={elementStyles}
						hidden={!props.sublabel}
					>
						{extras &&
						extras.paragraph &&
						extras.paragraph.isDynamic &&
						props.value
							? props.value
							: getProcessedSublabel(props.sublabel)}
					</p>
				</div>
			);
			sublabelNeeded = false;
			break;
		case 'readonly':
			inputElement = (
				<label className={classes['label-readonly']}>
					{props.value ? props.value : 'N/A'}
				</label>
			);
			break;
		case 'epicepiccare':
			inputElement = <EpicEpicCare {...props} />;
			labelNeeded = false;
			errorMessageNeeded = false;
			break;
		case 'bridgesepic':
			inputElement = <Bridges {...props} />;
			labelNeeded = false;
			errorMessageNeeded = false;
			break;
		case 'bridgesepiclink':
			inputElement = <BridgesLink {...props} />;
			labelNeeded = false;
			errorMessageNeeded = false;
			break;
		case 'healthplanetpremierpartnergroup':
			inputElement = <HealthPlanetPPG {...props} />;
			labelNeeded = false;
			errorMessageNeeded = false;
			break;
		case 'adgroupssearch':
			inputElement = <ADGroupsSearch {...props} />;
			labelNeeded = false;
			errorMessageNeeded = false;
			break;
		case 'epichp':
			inputElement = <EpicHP {...props} />;
			labelNeeded = false;
			errorMessageNeeded = false;
			break;
		default:
			break;
	}

	let sublabelOutput = null;
	if (props.sublabel && sublabelNeeded) {
		const sublabelStyle = indent ? 'label--sub-indented' : 'label--sub';
		sublabelOutput = (
			<Subtitle2 className={classes[sublabelStyle]}>
				{getProcessedSublabel(props.sublabel)}
			</Subtitle2>
		);
	}

	let requiredStar = props.validation.rules.required.value ? (
		<RequiredIndicator />
	) : (
		''
	);
	let labelOutput = null;
	if (props.label && labelNeeded) {
		const labelStyle = indent ? 'label-indented' : 'label';
		labelOutput = (
			<Headline6 className={classes[labelStyle]}>
				{requiredStar}
				{props.label}
			</Headline6>
		);
	}

	let output = null;
	if (inputElement) {
		output = (
			<StyleAuxiliary classes={isFormField ? 'mdc-form-field' : null}>
				{labelOutput}
				{sublabelOutput}
				{inputElement}
				{props.validation.message !== null &&
				errorMessageNeeded &&
				props.validation.message !== '' ? (
					<Subtitle2 className={classes['error-label']}>
						{props.validation.message}
					</Subtitle2>
				) : null}
			</StyleAuxiliary>
		);
	}

	return <div>{props.visible && output}</div>;
};

export default Input;
